import { createSvgIcon } from '@mui/material';

export const DetailsIcon = createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none">
    <path fill="currentColor" d="M4 19v-2h10v2H4Zm0-4v-2h16v2H4Zm0-4V9h16v2H4Zm0-4V5h16v2H4Z" />
  </svg>,
  'DetailsIcon',
);
